import { localStorageUtils } from '@/utils/local-storage-utils';
import axios from 'axios';

const publicApi = axios.create({
  baseURL: process.env.NEXT_PUBLIC_API_ENDPOINT,
  headers: {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${localStorageUtils.get('token')}`,
  },
});

export default publicApi;
